/*******************************************************************************
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 *
 *  *  Copyright © 2020 Pearson Education, Inc.
 *  *  All Rights Reserved.
 *  *
 *  * NOTICE:  All information contained herein is, and remains
 *  * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 *  * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 *  * patent applications, and are protected by trade secret or copyright law.
 *  * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 *  * is strictly forbidden unless prior written permission is obtained from Pearson Education, Inc.
 ******************************************************************************/


import React, { Suspense } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Layout from '../components/layout/Layout';
import * as AuthActions from '../actions/Auth'
import AppContext from '../common/AppContext'
import {getItem} from '../common/utils/StorageManager';
import { withRouter } from 'react-router';

import {teacherRoutes, noSubscriptionRoutes} from './routes'

export class Routes extends React.PureComponent {

  componentDidMount() {

  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    let userData = getItem('userData');
    let FusionKey = getItem('FusionKey');
    if(!userData){
     this.props.actions.getIesUserInfo();
    }
    if (userData && !FusionKey){
      this.props.actions.getFusionKey(); 
    }
   
  }

  render(){
    const { isAuth, userData, fusionKey }  = this.props;

    if(!isAuth || !userData)
    {
    
      return (<div>Loading...</div>)
    }

    if(userData && userData.error){
      return (<div>There is a problem loading the data. Please try refreshing the page.</div>)
      }

      let routes = [],
      isUserSubscribed = true;

    routes = teacherRoutes;
      console.log(userData.isSubscriptionEnabled)
      if(userData && !userData.isSubscriptionEnabled){
          console.log("Inside if case")
		      routes = noSubscriptionRoutes;
          isUserSubscribed = false;
      }

    

     const appContextValue =  {
          iesToken: this.props.accessToken,
          fusionKey : fusionKey
      }

    return (
      <AppContext.Provider value={appContextValue}>
     <Suspense fallback={<div>Loading...</div>}>
        <BrowserRouter >
          <Switch>
            { routes && routes.map((route, index) => {
              const { component: RouteComponent, exact, path, canHideHeader } = route;
              return (
                <Route
                  exact={ exact }
                  key={ index }
                  path={ path }
                  render={ (props) => (
                    <Layout { ...this.props } canHideHeader={ canHideHeader  } isUserSubscribed={isUserSubscribed} >
                      <RouteComponent { ...props } selectedLang={ 'en' } />
                    </Layout>
                  ) } />
              );
            })
            }
          </Switch>
        </BrowserRouter>
        </Suspense>
        </AppContext.Provider>
      
    )
  }
}

const mapStateToProps = (state) => ({
   isAuth: state.auth.isAuthenticated,
   userId: state.auth.userId,
   accessToken: state.auth.accessToken,
   userData: state.auth.userData,
   fusionKey :state.auth.key
})

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...AuthActions}, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Routes);
